import {getSelectedVendorFromStorage} from 'utils/Helper';

export const getExtraDeliveryVendorId = (): number => {
  const vendorId = getSelectedVendorFromStorage()?.id;
  const parsed = Number(vendorId);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizeExtraDeliveryState = (value?: string): string =>
  value?.toLowerCase?.() || value || '';
